
















































import { Component, Watch } from 'vue-property-decorator';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import DebitCreditCode from '@/models/Shared/DebitCreditCode';
import SingleAccountReportDialog from '@/components/Reporting/Reports/SingleAccountReportDialog.vue';
import ThirdPartyAccountTransactionDetailsDialog from '@/components/Accounts/ThirdPartyAccounts/ThirdPartyAccountTransactionDetailsDialog.vue';
import TransactionsOrderOptions from "@/models/Accounts/Shared/Transactions/TransactionsOrderOptions";
import AccountType from '@/models/Shared/AccountType';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'ThirdPartyAccount', components: { SingleAccountReportDialog, ThirdPartyAccountTransactionDetailsDialog } })
export default class extends SaascadaVue {

    search = '';
    AccountType = AccountType;
    TransactionsOrderOptions = TransactionsOrderOptions;

    // NOTE: There is no "display date" field for third party account transactions (its not possible) so we cannot swap the createdAt
    // field for displayDate depending on the selected sort order, as we do on institution account and customer acount transactions
    // NOTE: The 'value' field here is needed for local searching on the table, until server side searching is added
    headers = [
        { text: this.$t('pageText.thirdPartyAccounts.fields.reference'), value: 'transactionReference', sortable: false, width: '20%' },
        { text: this.$t('pageText.thirdPartyAccounts.fields.counterpartAccountName'), value: 'counterpartAccount.accountName', sortable: false, width: '25%' },
        { text: this.$t('pageText.thirdPartyAccounts.fields.direction'), sortable: false, width: '10%' },
        { text: this.$t('pageText.thirdPartyAccounts.fields.amount'), sortable: false, width: '15%' },
        { text: this.$t('pageText.thirdPartyAccounts.fields.createdAt'), sortable: false, width: '20%' },
        { text: this.$t('pageText.thirdPartyAccounts.fields.moreInfo'), sortable: false, width: '10%' }
    ];
    transactionsPage = 1;

    async beforeMount() {
        await InstitutionAccountModule.getThirdPartyTransactions(this.$route.params.id);
    }

    @Watch('transactionsOrderSelection')
    async onTransactionsOrderSelectionChanged() {
        await InstitutionAccountModule.getThirdPartyTransactions(this.$route.params.id);
    }

    get account() {
        return InstitutionAccountModule.thirdPartyAccount;
    }

    get transactions() {
        return InstitutionAccountModule.thirdPartyTransactions;
    }

    get totalTransactionsPages() {
        return InstitutionAccountModule.totalThirdPartyTransactionsPages;
    }

    get transactionsOrderOptions() {
        return ListUtils.transactionsOrderOptions();
    }

    get transactionsOrderSelection() {
        return InstitutionAccountModule.thirdPartyTransactionsOrder;
    }

    set transactionsOrderSelection(order: TransactionsOrderOptions) {
        InstitutionAccountModule.updateThirdPartyTransactionsOrder(order);
    }

    get loadingThirdPartyTransactions() {
        return InstitutionAccountModule.loadingThirdPartyTransactions;
    }

    get pageSize() {
        return InstitutionAccountModule.pageSize;
    }

    getDebitCreditClass(code: DebitCreditCode) {
        if (code === DebitCreditCode.debit) {
            return "error--text";
        }
        else {
            return "success--text";
        }
    }

}
